import React, { Component } from 'react';
import HomeContent from '../components/home/HomeContent';
import HomeHero from '../components/home/HomeHero';
import { projectList } from '../service/data/projectList';
import "../assets/scss/home/home.scss"
import variables from "../assets/scss/variables.module.scss";
import Drip3 from 'components/home/Drip3';


class Home extends Component {

    componentDidMount() {
        document.body.style.backgroundColor = variables.homeBgDark;
    }

    render() {
        return (
            <div>
                <HomeHero />
                <Drip3 />
                <HomeContent list={projectList} />
            </div>
        );
    }
}

export default Home;